import { render, staticRenderFns } from "./tallaParaLaEdadNinos0a2A.vue?vue&type=template&id=8146196c&scoped=true"
import script from "./tallaParaLaEdadNinos0a2A.vue?vue&type=script&lang=js"
export * from "./tallaParaLaEdadNinos0a2A.vue?vue&type=script&lang=js"
import style0 from "./tallaParaLaEdadNinos0a2A.vue?vue&type=style&index=0&id=8146196c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8146196c",
  null
  
)

export default component.exports